import {
  IStandardAPIResponse,
  ISystemConfig,
  ISystemConfigSearch,
} from "../../vm";
import { httpClient, handleErrorResp } from "../UtilService";

export async function getAllSystemConfigs(
  searchObj?: ISystemConfigSearch
): Promise<IStandardAPIResponse<Array<ISystemConfig>>> {
  try {
    let res = await httpClient<Array<ISystemConfig>>(
      `system-configs`,
      "GET",
      searchObj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function addSystemConfig(
  data: ISystemConfig
): Promise<IStandardAPIResponse<ISystemConfig>> {
  try {
    let res = await httpClient<ISystemConfig>(`system-configs`, "PUT", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateSystemConfig(
  data: ISystemConfig
): Promise<IStandardAPIResponse<ISystemConfig>> {
  try {
    let res = await httpClient<ISystemConfig>(
      `system-configs/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function deleteSystemConfig(
  data: ISystemConfig
): Promise<IStandardAPIResponse<ISystemConfig>> {
  try {
    let res = await httpClient<ISystemConfig>(
      `system-configs/${data._id}`,
      "DELETE"
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
